import { render } from "./PageNumber15.vue?vue&type=template&id=6a8eee27&scoped=true"
import script from "./PageNumber15.vue?vue&type=script&lang=js"
export * from "./PageNumber15.vue?vue&type=script&lang=js"

import "./PageNumber15.vue?vue&type=style&index=0&id=6a8eee27&scoped=true&lang=css"

import exportComponent from "/home/alex/Documents/EVO/investorpresentation/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a8eee27"]])

export default __exports__